onLoad(($) => {
  // Gestor/Fundo do monitor usam managers.js (ajax); não inicializar aqui também.
  $('.JS-select-autocomplete')
    .not('.JS-managers, .JS-funds, .JS-funds-2, .JS-invested-funds, .JS-invested-funds-passive, .JS-invested-funds-passive-monitor, .JS-secondary-requesting-fund, .JS-addendum-operation')
    .each(function () {
      const $el = $(this);
      if ($el.hasClass('select2-hidden-accessible')) return;

      $el.select2({
    theme: 'bootstrap4',
    language: {
      noResults: function() {
        return "Nenhum resultado foi encontrado.";
      }
    },
  });
    });

  initProposalTitleTypeMultiselect($);

  // Inicialização customizada para select de tipos de usuário
  $('.select2-custom').select2({
    theme: 'bootstrap4',
    language: {
      noResults: function() {
        return "Nenhum resultado foi encontrado.";
      },
      searching: function() {
        return "Procurando...";
      }
    },
    width: '100%',
    allowClear: true,
    closeOnSelect: false,
    tags: false
  });
});

function proposalTitleTypeLabel(data) {
  if (!data.id) return data.text;

  const $option = data.element ? $(data.element) : null;
  const chipLabel = $option && $option.data('chipLabel');
  if (chipLabel) return chipLabel;

  return data.text;
}

function initProposalTitleTypeMultiselect($ = window.jQuery) {
  if (!$) return;

  $('.JS-proposal-title-type-multiselect').each(function () {
    const $el = $(this);
    if ($el.hasClass('select2-hidden-accessible')) {
      $el.select2('destroy');
    }

    $el.select2({
      theme: 'bootstrap4',
      width: '100%',
      closeOnSelect: false,
      placeholder: $el.data('placeholder') || 'Todos os tipos',
      templateSelection(data) {
        return proposalTitleTypeLabel(data);
      },
      language: {
        noResults() {
          return 'Nenhum resultado foi encontrado.';
        },
        searching() {
          return 'Buscando...';
        }
      }
    });
  });
}

window.initProposalTitleTypeMultiselect = initProposalTitleTypeMultiselect;
